import { AbstractControl, FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example:
 * { data: { construction_elements: ["fieldName1", "fieldName2"], sum: "100"}}
 * @returns true if validation passed. An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */
export function productCalculator(
  control: AbstractControl,
  form: FormlyFieldConfig,
  options: any = {}
) {
  const model = control.value;
  let operands: any[] = [];
  let product: number | undefined = undefined;
  let productOperands: number[] = [];

  // We multiply model values. If model is empty, we don't care
  if (model === undefined && !options && !options.data && !options.productField) {
    return null;
  }

  // multiply all operands
  try {
    if (options.data) {
      operands = options.data;
    } else {
      // Collect all inputs of props.type="number"
      getElementsOfType(form?.parent?.parent?.fieldGroup as Array<FormlyFieldConfig>, operands);

      // Remove elements in exclusions from operands array
      let exclusions: string[] = [options.productField];
      if (options.exclusions) {
        exclusions = [...exclusions, ...options.exclusions];
      }
      operands = operands.filter(function (el) {
        return exclusions.indexOf(el) < 0;
      });
    }


    operands.forEach((operandFieldName) => {
      const multiplyCtrl = form?.parent?.formControl;
      const multiplyCtrl1 = multiplyCtrl ? multiplyCtrl['controls'] : undefined;
      const multiplyItem = multiplyCtrl1 ? multiplyCtrl1[operandFieldName] : undefined;
      
      if (multiplyItem.value !== undefined) {
        const multiplyValue = multiplyItem.value;
        const modelOperand = +multiplyValue;
        if (multiplyValue !== undefined) {
          productOperands.push(modelOperand);
        }
      }
    });

    if (productOperands.length === 1) {
      product = undefined;
      // console.log('Array has only one element. result is undefined');
    } else if (productOperands.length > 1) {
      product = productOperands.reduce((acc, curr) => acc * curr, 1);
    } else {
      product = undefined;
      // console.log('Array is empty')
    }

    // Change the product control, but don't emit events or transmit change to parent
    if (product !== undefined && options.productField && form?.parent?.formControl instanceof FormGroup) {
      const multiplyCtrl = form?.parent?.formControl;
      const multiplyCtrl1 = multiplyCtrl ? multiplyCtrl['controls'] : undefined;
      const productItem = multiplyCtrl1 ? multiplyCtrl1[options.productField] : undefined;

      if (productItem) {
        productItem.patchValue(product);
      }
    }
  } catch (error: any) {
    console.warn("multiplication exception " + error.toString());
  }

  return null;
}


export function getElementsOfType(
  fieldGroup: FormlyFieldConfig[],
  list: any[]
) {
  if (fieldGroup && fieldGroup.length > 0) {
    fieldGroup.forEach((field) => {
      if (field.key && field.props && field.props.type === 'number') {
        list.push(field.key);
      } else if (field.fieldGroup) {
        getElementsOfType(field.fieldGroup, list);
      }
    });
  }
}
